import { GridRenderEditCellParams, GridEditInputCell } from "@mui/x-data-grid";

function PasswordInputCell(props: GridRenderEditCellParams) {
  const { ref } = props;
    return (
        <GridEditInputCell type="password" ref={ref} {...props} />
    );
}

export default PasswordInputCell;